/**
 * Sort an array of stock objects by a given key and order.
 *
 * Supports dot-notation keys (e.g. "growth_estimates.next_year") for nested
 * properties.  Null / undefined values are always pushed to the end of the
 * list regardless of sort direction.
 *
 * @param {Array}  stocks   - The array of stock objects to sort.
 * @param {string} sortKey  - The property (or dot-path) to sort by.
 * @param {string} order    - "asc" or "desc".
 * @returns {Array} A new sorted array (the original is not mutated).
 */
// Sort option keys that do not map 1:1 onto a stock property.
export const SORT_KEY_MAP = {
    total_growth: 'growth',
    value: 'total_value',
    next_year_growth: 'growth_estimates.next_year',
    current_qtr_growth: 'growth_estimates.current_qtr',
    next_qtr_growth: 'growth_estimates.next_qtr',
    current_year_growth: 'growth_estimates.current_year'
};

export const sortStocks = (stocks, sortBy, order) => {
    const sortKey = SORT_KEY_MAP[sortBy] || sortBy;
    return [...stocks].sort((a, b) => {
        const getValue = (obj, key) => {
            if (key.includes('.')) return key.split('.').reduce((curr, prop) => curr?.[prop], obj);
            return obj[key];
        };

        let aValue = getValue(a, sortKey);
        let bValue = getValue(b, sortKey);

        const aIsNull = aValue === null || aValue === undefined;
        const bIsNull = bValue === null || bValue === undefined;
        if (aIsNull && bIsNull) return 0;
        if (aIsNull) return 1;
        if (bIsNull) return -1;

        const aNum = parseFloat(aValue);
        const bNum = parseFloat(bValue);
        if (!isNaN(aNum) && !isNaN(bNum)) {
            return order === 'asc' ? aNum - bNum : bNum - aNum;
        }

        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();
        if (aStr < bStr) return order === 'asc' ? -1 : 1;
        if (aStr > bStr) return order === 'asc' ? 1 : -1;
        return 0;
    });
};
